import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'get'

export default class OspreyContentBlocksGetById extends BaseAction {
    constructor(dataKey) {
        const id = '9efb756e-b91c-4b5a-8fee-096051b6d5ff'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getById(contentBlockId, params) {
        this.params = params
        this.path = `/${resource}/${contentBlockId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-get-by-id.js